import { isProductEligibleForCheckout } from '@brandclub/common-ui';
import type { ProductRewardSearchResult } from '@brandclub/common-ui';
import _orderBy from 'lodash/orderBy';
import type { ReactNode } from 'react';

export type CheckoutAllowedOfferType = 'firstPartyOnly' | 'thirdPartyOnly' | 'both';

interface InpageAddToBagContentProps {
  renderAddToBagButton: (options: { hideRewards: boolean }) => ReactNode;
  renderLocationMap: () => ReactNode;
  renderRetailerInfo: (options: { hideMatchedRetailOffers: boolean }) => ReactNode;
}

export const getCatalogV1PriorityEligibleProduct = (
  currentProduct?: ProductRewardSearchResult,
  checkoutAllowedOfferType?: CheckoutAllowedOfferType,
  checkoutRetailerIds?: number[],
): ProductRewardSearchResult | undefined => {
  if (!currentProduct) return undefined;

  const checkoutRetailerIdSet = checkoutRetailerIds?.length ? new Set(checkoutRetailerIds) : undefined;
  const allProducts: ProductRewardSearchResult[] = [
    currentProduct,
    ...((currentProduct.matchedProducts || []) as ProductRewardSearchResult[]),
  ];
  const checkoutCandidates = checkoutRetailerIdSet
    ? allProducts.filter((product) => checkoutRetailerIdSet.has(product.retailerId))
    : allProducts;

  if (checkoutCandidates.length === 0) return undefined;

  const getEffectivePrice = (p: ProductRewardSearchResult) => (p.retailPrice || 0) - (p.totalRewardAmount || 0);
  const getRetailerId = (p: ProductRewardSearchResult) => String(p.retailerId ?? '');

  const eligibleProducts = checkoutCandidates.filter((p) =>
    isProductEligibleForCheckout(p as any, checkoutAllowedOfferType),
  );

  if (eligibleProducts.length > 0) {
    return _orderBy(eligibleProducts, [getEffectivePrice, getRetailerId], ['asc', 'asc'])[0];
  }

  return _orderBy(checkoutCandidates, [getEffectivePrice, getRetailerId], ['asc', 'asc'])[0];
};

export const CatalogV1InpageAddToBagContent = ({
  renderAddToBagButton,
  renderLocationMap,
  renderRetailerInfo,
}: InpageAddToBagContentProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      {renderAddToBagButton({ hideRewards: false })}
      {renderRetailerInfo({ hideMatchedRetailOffers: false })}
      {renderLocationMap()}
    </div>
  );
};
